
import { Link } from 'react-router-dom';
import { blogPosts } from '../../../mocks/blogPosts';

export default function BlogHero() {
  const featured = blogPosts.filter((p) => p.featured).slice(0, 2);
  const main = featured[0];
  const secondary = featured[1];

  if (!main) return null;

  return (
    <section className="pt-32 pb-16 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-12">
          <p className="text-[#2E7D32] text-sm tracking-widest font-medium mb-3">(THE JOURNAL)</p>
          <h1 className="text-5xl font-serif text-gray-900 mb-4">
            <a href="/blog">Beauty &amp; Fragrance Insights</a>
          </h1>
          <p className="text-gray-500 text-base max-w-xl">
            Expert guides on <strong>luxury perfumes</strong>, <strong>natural hair care</strong>, and <strong>sustainable beauty</strong> from our team of specialists.
          </p>
        </div>

        <div className="grid grid-cols-5 gap-6">
          {/* Main Featured */}
          <Link
            to={`/blog/${main.id}`}
            className="col-span-3 group cursor-pointer block rounded-2xl overflow-hidden relative h-[420px]"
          >
            <div className="absolute inset-0">
              <img
                src={main.image}
                alt={main.title}
                title={`${main.title} - Daliah Secret Blog`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-8">
              <span className="inline-block px-3 py-1 bg-[#2E7D32] text-white text-xs font-medium rounded-full mb-3 tracking-wider">
                {main.category}
              </span>
              <h2 className="text-2xl font-serif text-white mb-2 leading-snug group-hover:text-[#A5D6A7] transition-colors">
                {main.title}
              </h2>
              <p className="text-white/80 text-sm mb-3 line-clamp-2">{main.excerpt}</p>
              <div className="flex items-center gap-3 text-white/60 text-xs">
                <span>{main.author}</span>
                <span>·</span>
                <span>{main.date}</span>
                <span>·</span>
                <span>{main.readTime}</span>
              </div>
            </div>
          </Link>

          {/* Secondary Featured */}
          {secondary && (
            <Link
              to={`/blog/${secondary.id}`}
              className="col-span-2 group cursor-pointer block rounded-2xl overflow-hidden relative h-[420px]"
            >
              <div className="absolute inset-0">
                <img
                  src={secondary.image}
                  alt={secondary.title}
                  title={`${secondary.title} - Daliah Secret Blog`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <span className="inline-block px-3 py-1 bg-[#2E7D32] text-white text-xs font-medium rounded-full mb-3 tracking-wider">
                  {secondary.category}
                </span>
                <h2 className="text-xl font-serif text-white mb-2 leading-snug group-hover:text-[#A5D6A7] transition-colors">
                  {secondary.title}
                </h2>
                <p className="text-white/80 text-sm mb-3 line-clamp-2">{secondary.excerpt}</p>
                <div className="flex items-center gap-3 text-white/60 text-xs">
                  <span>{secondary.author}</span>
                  <span>·</span>
                  <span>{secondary.readTime}</span>
                </div>
              </div>
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}
